import { render, staticRenderFns } from "./ng-admin-modal.vue?vue&type=template&id=20f1dc10&scoped=true&"
import script from "./ng-admin-modal.vue?vue&type=script&lang=js&"
export * from "./ng-admin-modal.vue?vue&type=script&lang=js&"
import style0 from "./ng-admin-modal.vue?vue&type=style&index=0&id=20f1dc10&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f1dc10",
  null
  
)

export default component.exports